<template>
    <ns-modal v-model="dialog" :fullscreen="fullscreen" :title="txc.edit_preferred_name" @input="closeDialog">
        <server-error v-if="!!dialogError" :error="dialogError"/>
        <v-form ref="preferredNameForm" v-model="form" @submit.prevent>
            <p>{{txc.preferred_name_description}}</p>
            <section v-if="currentPreferredName!=''">
                <div class="field-label">{{txc.current_preferred_name}}</div>
                <div class="field-value">{{currentPreferredName  || txc.no_preferred_name}}</div>
            </section>
            <div class="field-label">{{txc.new_preferred_name}}</div>
            <v-text-field
                v-model="userPreferredName"
                :placeholder="sharedStrings.generic.optional"
                :rules="[invalidCharRule,]"
                maxlength="33"/>
        </v-form>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        :disabled="!form"
                        class="primary-hit mb-2 fluid"
                        @click="editPreferredName()"
                        data-test-id="personalInfo-preferredName-modal-save"
                    >{{sharedStrings.generic.save}}
                    </button>
                </v-flex>
                <v-spacer/>
                <v-flex xs12>
                    <button
                        flat
                        block
                        outline
                        class="secondary-hit fluid"
                        @click="closeDialog()"
                        data-test-id="personalInfo-preferredName-modal-cancel"
                    >{{sharedStrings.generic.cancel}}
                    </button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import * as ruleSet from '@/repositories/globalRules.js';
import profileUtils from '@/repositories/profileUtils';

import { UserService, ProfileService } from '@nuskin/ns-account';
import { events } from '@nuskin/ns-util';
import { NsModal } from '@nuskin/design-components';
import ServerError from '@/components/ServerError';

import { mapGetters , mapActions} from 'vuex';


export default {
    components: {
        NsModal,
        ServerError
    },
    props: ['currentPreferredName','fullscreen'],
    data() {
        return {
            ruleSet,
            userPreferredName: '',
            dialogError: null,
            dialog: true,
            form:{}
        }
    },
    computed: {
        ...mapGetters({
            txc: 'translationsPersonal',
            sharedStrings: 'sharedStrings'
        })
    },
    methods: {
        ...mapActions(['updatePreferredName']),

        closeDialog(){
            this.$emit('closeDialog');
            this.dialog = false;
            this.dialogError = null;
        },
        invalidCharRule(v) {
            return !(/[<>&]/gi.test(v)) || this.sharedStrings.password.invalidCharInName;
        },
        /**
             * Do some things once the preferred name is updated
             *
             * @param {string} name - The preferred name
             */
        preferredNameUpdated(name) {
            let user = UserService.getUser();
            user.displayName = name;
            UserService.setUser(user);
            profileUtils.publishAnalytics(this.$analytics.category.personal, 'preferred_name', 'updated');

            // update header
            events.publish(events.account.PREFERRED_NAME_UPDATE, name);
            // update Store
            this.updatePreferredName(name);
            this.closeDialog();
        },
        /**
             * Call service endpoint for updating preferred name
             */
        editPreferredName() {
            let self = this;
            const encodedName = this.$sanitize(this.userPreferredName);
            ProfileService.updatePreferredName(encodedName).then(
                function (response) {
                    if (response.data.alias != null || response.data.alias !== undefined) {
                        self.preferredNameUpdated(response.data.alias);
                    }
                }
            ).catch(error => {
                self.dialogError = error;
            });
        }
    },
    created() {
        profileUtils.publishAnalytics(this.$analytics.category.personal, 'preferred_name_dialog', 'opened');
    },
    destroyed() {
        profileUtils.publishAnalytics(this.$analytics.category.personal, 'preferred_name_dialog', 'closed');
    }
}
</script>
<style scoped>
</style>